import {AppLanguage} from './app-language.model';

export interface MaterialPaginatorLabels {
  firstPageLabel: string;
  itemsPerPageLabel: string;
  lastPageLabel: string;
  nextPageLabel: string;
  previousPageLabel: string;
  rangeSeparatorLabel: string;
}

export const MATERIAL_PAGINATOR_LABELS: Record<AppLanguage, MaterialPaginatorLabels> = {
  mk: {
    firstPageLabel: 'Прва страница',
    itemsPerPageLabel: 'Записи по страница',
    lastPageLabel: 'Последна страница',
    nextPageLabel: 'Следна страница',
    previousPageLabel: 'Претходна страница',
    rangeSeparatorLabel: 'од'
  },
  en: {
    firstPageLabel: 'First page',
    itemsPerPageLabel: 'Items per page',
    lastPageLabel: 'Last page',
    nextPageLabel: 'Next page',
    previousPageLabel: 'Previous page',
    rangeSeparatorLabel: 'of'
  }
};

export function getMaterialPaginatorRangeLabel(
  page: number,
  pageSize: number,
  length: number,
  language: AppLanguage = 'mk'
): string {
  const separator = MATERIAL_PAGINATOR_LABELS[language].rangeSeparatorLabel;

  if (length === 0 || pageSize === 0) {
    return `0 ${separator} ${length}`;
  }

  const startIndex = page * pageSize;
  const endIndex = Math.min(startIndex + pageSize, length);

  return `${startIndex + 1}-${endIndex} ${separator} ${length}`;
}
